import {
    Button,
    MenuItem,
    Modal,
    TextField,
    FormControlLabel,
    Checkbox,
    FormGroup,
    Typography,
    InputAdornment,
    Autocomplete
} from "@mui/material";
import { React, useState, useContext, useEffect } from 'react'
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ValTasaInteres } from "../../Credito/InteresesJDF/ValTasaInteres";
import { ValOnlyNumber } from "../../../Validators/ValOnlyNumber";
import { Moneda } from "../../../Helpers/Moneda";

const ModalAgregarPolizaMantenimiento = ({ updatedata, onClose, open, idpoliza, setIdPoliza }) => {

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [clienteslist, setClienteList] = useState([]);
    const [vendedores, setVendedores] = useState([]);

    const [poliza, setPoliza] = useState({
        sucursal: "",
        cliente: "",
        serie: "",
        numFactura: "",
        ot: "",
        facturacion: "",
        periodo: "",
        refacciones: 0,
        mes: "",
        km: 0,
        ejercicio: "",
        manoObra: 0,
        tipo: "",
        vendedor: "",
    });

    const year = new Date().getFullYear();

    // Crear array con los 3 años: actual, actual -1, actual -2
    const opcionesEjercicio = [
        year + 1,
        year,
        year - 1,
        year - 2
    ];


    const Editar = () => {

        if (idpoliza !== null || idpoliza !== "" || idpoliza !== -1 || idpoliza !== undefined) {
            request
                .get(`PolizaMantenimiento/ObtenerID?idpoliza=${idpoliza}`)
                .then((result) => {

                    // console.log(result)
                    setPoliza({
                        ...poliza,
                        sucursal: result.idsucursal,
                        cliente: result.idcliente,
                        serie: result.serie,
                        numFactura: result.num_factura,
                        ot: result.orden_trabajo,
                        facturacion: result.facturacion,
                        periodo: result.periodo,
                        refacciones: result.refacciones,
                        mes: result.mes,
                        km: result.km,
                        ejercicio: result.ejercicio,
                        manoObra: result.mano_obra,
                        tipo: result.tipo,
                        vendedor: result.idvendedor,
                    })
                })
                .catch((error) => {
                    Swal.fire("INTERESES", JSON.stringify(error), "error");
                });

        } else {
            return;
        }
    }

    useEffect(() => {

        if (idpoliza !== undefined && idpoliza !== null && Number(idpoliza) > 0) {
            Editar();
        } else {

        }
    }, [updatedata]);

    useEffect(() => {
        const facturacion = Number(poliza.refacciones) + Number(poliza.km) + Number(poliza.manoObra)

        setPoliza({
            ...poliza,
            facturacion: facturacion
        })

    }, [poliza.refacciones, poliza.km, poliza.manoObra]);


    const onGuardar = () => {

        const post = {
            idpoliza: idpoliza,
            idsucursal: poliza.sucursal,
            idcliente: poliza.cliente,
            serie: poliza.serie,
            periodo: poliza.periodo,
            num_factura: poliza.numFactura,
            tipo: poliza.tipo,
            mano_obra: poliza.manoObra,
            refacciones: poliza.refacciones,
            km: poliza.km,
            facturacion: poliza.facturacion,
            orden_trabajo: poliza.ot,
            ejercicio: poliza.ejercicio,
            mes: poliza.mes,
            idvendedor: poliza.vendedor,

        }

        // Verificar campos vacíos o undefined
        const camposInvalidos = Object.entries(post)
            .filter(([key, value]) => value === "" || value === undefined)
            .map(([key]) => key);

        if (camposInvalidos.length > 0) {
            Swal.fire({
                icon: 'warning',
                title: 'POWERGARD',
                html: `Los siguientes campos están vacíos:<br><strong>${camposInvalidos.join('</strong>, <strong>')}</strong>`,
                confirmButtonText: 'Aceptar'
            });
            return false;
        }


        const soloNumerosRegex = /^\d+$/;

        if (!soloNumerosRegex.test(poliza.numFactura) || !soloNumerosRegex.test(poliza.ot)) {
            Swal.fire({
                icon: 'error',
                title: 'POWERGARD',
                text: 'Los campos "Número de Factura" y "Orden de Trabajo" solo pueden contener números.',
                confirmButtonText: 'Aceptar'
            });
            return false;
        }

        request
            .post("PolizaMantenimiento", post)
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                updatedata()
                await Swal.fire({
                    title: "POLIZA MANTENIMIENTO",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });

                setPoliza({
                    ...poliza,
                    sucursal: "",
                    cliente: "",
                    serie: "",
                    numFactura: "",
                    ot: "",
                    facturacion: 0,
                    periodo: "",
                    refacciones: 0,
                    mes: "",
                    km: 0,
                    ejercicio: "",
                    manoObra: 0,
                    tipo: "",
                    vendedor: "",
                })
                onClose();
                updatedata()
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("POLIZA MANTENIMIENTO", JSON.stringify(error), "error");
            });
    }

    const onCerrar = () => {
        setPoliza({
            ...poliza,
            sucursal: "",
            cliente: "",
            serie: "",
            numFactura: "",
            ot: "",
            facturacion: 0,
            periodo: "",
            refacciones: 0,
            mes: "",
            km: 0,
            ejercicio: "",
            manoObra: 0,
            tipo: "",
            vendedor: "",
        })
        setIdPoliza(-1)
        onClose()
    }

    useEffect(() => {
        request
            .get("Clientes/DropDownList")
            .then((result) => {
                setClienteList(result);
            })
            .catch((error) => {
                Swal.fire("CLIENTES", JSON.stringify(error), "error");
            });

        request
            .get("DDLVendedor/Listado")
            .then((result) => {
                // setLoading(false);
                setVendedores(result);
            })
            .catch((error) => {
                // setLoading(false);
                Swal.fire("VENDEDOR", JSON.stringify(error), "error");
            });
    }, []);

    const onChange = (prop, value, sbool, smensaje) => {
        const sinComas = value.replace(/,/g, "");
        setPoliza({
            ...poliza,
            [prop]: sinComas,
        });
    };

    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    return (
        <Modal open={open}>
            <div className="modal-agregar-powergard-main-container">
                <div className="credito-agregar-modal-title">

                    <div className="modal-agregar-powergard-main-titulo">
                        <h3>AGREGAR POWERGARD </h3>
                    </div>
                </div>
                <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
                    <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            // fullWidth
                            size="small"
                            label="Sucursal"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,
                                    sucursal: target.value
                                });
                            }}
                            value={poliza.sucursal}
                        >
                            <MenuItem value={"1"}>NAVOLATO</MenuItem>
                            <MenuItem value={"2"}>TEPIC</MenuItem>
                            <MenuItem value={"11"}>CAIMANERO</MenuItem>
                            <MenuItem value={"12"}>SAN JOSE</MenuItem>
                            <MenuItem value={"21"}>ELDORADO</MenuItem>
                            <MenuItem value={"22"}>SANTIAGO I.</MenuItem>
                            <MenuItem value={"31"}>COSTA RICA</MenuItem>
                            <MenuItem value={"32"}>TECUALA</MenuItem>
                            <MenuItem value={"41"}>LA CRUZ</MenuItem>
                            <MenuItem value={"51"}>EL ROSARIO</MenuItem>
                            <MenuItem value={"52"}>SAN VICENTE</MenuItem>
                            <MenuItem value={"61"}>VILLA UNION</MenuItem>
                        </TextField>

                        <Autocomplete
                            id="dash-razonsocial"
                            freeSolo
                            className="celda-clientes"
                            fullWidth
                            value={
                                poliza.cliente != null
                                    ? clienteslist.find(c => c.id === poliza.cliente.toString()) || null
                                    : null
                            }
                            onChange={(event, newValue) => {
                                if (typeof newValue === 'object' && newValue !== null) {
                                    setPoliza({
                                        ...poliza,
                                        cliente: newValue.id // <-- Aquí guardas el id
                                    });
                                } else {
                                    // Si es un string (por ejemplo, en modo freeSolo)
                                    setPoliza({
                                        ...poliza,
                                        cliente: newValue
                                    });
                                }
                            }}
                            options={clienteslist}
                            getOptionLabel={(option) =>
                                typeof option === 'string' ? option : option.display
                            }
                            renderInput={(params) => (
                                <TextField
                                    sx={{
                                        height: '40px',
                                        '& .MuiInputBase-root': {
                                            height: '40px',
                                            minHeight: '40px',
                                            fontSize: '0.875rem',
                                            padding: '0 8px',
                                        },
                                        '& input': {
                                            height: '40px',
                                            padding: '0 8px',
                                            boxSizing: 'border-box',
                                            display: 'flex',
                                            alignItems: 'center',
                                        },
                                        '& .MuiInputLabel-root': {
                                            fontSize: '0.85rem',
                                            top: '-6px',
                                        },
                                        '& .MuiInputLabel-shrink': {
                                            top: '0',
                                        },
                                    }}
                                    {...params}
                                    label="SELECCIONAR CLIENTE"
                                    InputLabelProps={{ shrink: true }} // Hace que el label no se solape
                                />
                            )}
                        />

                    </div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            id="clientes-documento"
                            label="# Factura"
                            type="text"
                            value={poliza.numFactura}
                            onChange={({ target }) => {
                                ValOnlyNumber("numFactura", target.value, onChange, true, 15);
                            }}
                            // onChange={({ target }) => {
                            //     setPoliza({
                            //         ...poliza,

                            //         numFactura: target.value,
                            //     });
                            // }}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            id="clientes-documento"
                            label="Serie"
                            type="text"
                            value={poliza.serie}
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,

                                    serie: target.value,
                                });
                            }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            id="clientes-documento"
                            label="OT"
                            type="text"
                            value={poliza.ot}
                            onChange={({ target }) => {
                                ValOnlyNumber("ot", target.value, onChange, true, 15);
                            }}
                            // onChange={({ target }) => {
                            //     setPoliza({
                            //         ...poliza,

                            //         ot: target.value,
                            //     });
                            // }}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            id="manoObra"
                            label="Mano de Obra"
                            type="text"
                            value={poliza.manoObra === 0 ? 0 : formatWithCommas(poliza.manoObra)}
                            onKeyUp={(input) => Moneda(input.target)}
                            onChange={({ target }) => {
                                ValOnlyNumber("manoObra", target.value, onChange, true, 10);
                            }}
                            // value={poliza.manoObra}
                            // onChange={({ target }) => {
                            //     setPoliza({
                            //         ...poliza,

                            //         manoObra: target.value,
                            //     });
                            // }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            id="clientes-documento"
                            label="Periodo"
                            type="text"
                            value={poliza.periodo}
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,

                                    periodo: target.value,
                                });
                            }}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            id="clientes-documento"
                            label="Refacciones"
                            type="text"
                            value={poliza.refacciones === 0 ? 0 : formatWithCommas(poliza.refacciones)}
                            onKeyUp={(input) => Moneda(input.target)}
                            onChange={({ target }) => {
                                ValOnlyNumber("refacciones", target.value, onChange, true, 10);
                            }}
                            // onChange={({ target }) => {
                            //     setPoliza({
                            //         ...poliza,

                            //         refacciones: target.value,
                            //     });
                            // }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            // fullWidth
                            size="small"
                            label="Mes"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,
                                    mes: target.value
                                });
                            }}
                            value={poliza.mes}
                        >
                            <MenuItem value={"1"}>Enero</MenuItem>
                            <MenuItem value={"2"}>Febrero</MenuItem>
                            <MenuItem value={"3"}>Marzo</MenuItem>
                            <MenuItem value={"4"}>Abril</MenuItem>
                            <MenuItem value={"5"}>Mayo</MenuItem>
                            <MenuItem value={"6"}>Junio</MenuItem>
                            <MenuItem value={"7"}>Julio</MenuItem>
                            <MenuItem value={"8"}>Agosto</MenuItem>
                            <MenuItem value={"9"}>Septiembre</MenuItem>
                            <MenuItem value={"10"}>Octubre</MenuItem>
                            <MenuItem value={"11"}>Noviembre</MenuItem>
                            <MenuItem value={"12"}>Diciembre</MenuItem>
                        </TextField>
                        <TextField
                            id="clientes-documento"
                            label="KM"
                            type="text"
                            value={poliza.km === 0 ? 0 : formatWithCommas(poliza.km)}
                            onKeyUp={(input) => Moneda(input.target)}
                            onChange={({ target }) => {
                                ValOnlyNumber("km", target.value, onChange, true, 10);
                            }}
                            // onChange={({ target }) => {
                            //     setPoliza({
                            //         ...poliza,

                            //         km: target.value,
                            //     });
                            // }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            fullWidth
                            size="small"
                            label="Año"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,

                                    ejercicio: target.value,
                                });
                            }}
                            value={poliza.ejercicio}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        >
                            {opcionesEjercicio.map((anio) => (
                                <MenuItem key={anio} value={anio.toString()}>
                                    {anio}
                                </MenuItem>
                            ))}
                        </TextField>

                        <TextField
                            id="facturacion"
                            label="Facturacion"
                            type="text"
                            value={poliza.facturacion === 0 ? 0 : formatWithCommas(poliza.facturacion)}
                            onKeyUp={(input) => Moneda(input.target)}
                            onChange={({ target }) => {
                                ValOnlyNumber("facturacion", target.value, onChange, true, 10);
                            }}
                            disabled={true}
                            // onChange={({ target }) => {
                            //     setPoliza({
                            //         ...poliza,

                            //         facturacion: target.value,
                            //     });
                            // }}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="modal-agregar-powergard-doble-input">
                        <TextField
                            fullWidth
                            size="small"
                            label="Interna/Externa"
                            variant="outlined"
                            className="cell-corta"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,
                                    tipo: target.value
                                });
                            }}
                            value={poliza.tipo}
                            sx={{
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        >
                            <MenuItem value={"I"}>Interna</MenuItem>
                            <MenuItem value={"E"}>Externa</MenuItem>
                        </TextField>

                        <TextField
                            fullWidth
                            size="small"
                            label="Vendedor"
                            variant="outlined"
                            className="cel-1"
                            select
                            type="text"
                            onChange={({ target }) => {
                                setPoliza({
                                    ...poliza,
                                    vendedor: target.value,
                                });
                            }}
                            value={poliza.vendedor}
                            sx={{
                                width: 540,
                                height: '40px',
                                '& .MuiInputBase-root': {
                                    height: '40px',
                                    fontSize: '0.875rem',
                                    padding: '0 8px',
                                },
                                '& input': {
                                    height: '40px',
                                    boxSizing: 'border-box',
                                    padding: '0 8px',
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.85rem',
                                    top: '-6px',
                                },
                                '& .MuiInputLabel-shrink': {
                                    top: '0',
                                },
                            }}
                            InputLabelProps={{ shrink: true }}
                        >
                            {vendedores.map((item) => (
                                <MenuItem key={item.idvendedor} value={item.idvendedor}>
                                    {item.vendedor}
                                </MenuItem>
                            ))}
                        </TextField>
                    </div>

                </div>

                <div className="credito-crear-tasa-interes-modal-button-container ">
                    <Button onClick={onCerrar} variant="contained" color="error">
                        Cerrar
                    </Button>
                    <Button variant="contained"
                        onClick={() => onGuardar()}
                    >
                        Agregar
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalAgregarPolizaMantenimiento
